import type { FaireProductEntity } from "../../entity_types/product";

export const p_alttfl66jh: FaireProductEntity = {
  token: "p_alttfl66jh",
  type: "product",
  name: "A Slice of Life Minnesota Cutting & Charcuterie Board",
  brandName: "Totally Bamboo",
  imageUrl:
    "https://cdn.faire.com/fastly/b79471c2a6f3610f13a04465ead8a822ad8cde8ef5d8a24fd0a4bbc9e3f36d25.jpeg",
  priceDollars: 10,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/bba4449887c296f484ea27239b134d0ee9be70acd4511a729e27cd50f0eb1aa0.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
